// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"355":"b0596c4e","453":"d90777c4","721":"6b0ba5fe"}[chunkId] + ".chunk.js");